<template>
  <div class="columns folio-headers">
    <comparador-folio-header
      v-for="(item, index) in folios"
      :key="`folio-header-item-${index}`"
      :folio="item"
      :esta-abierto="estaAbierto"
      class="is-pulled-left"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ComparadorFolioHeader from '@/components/comparador-v2/ComparadorFolioHeader'

export default {
  name: 'ComparadorFolioHeaders',
  components: {
    ComparadorFolioHeader
  },
  data() {
    return {
      showScroll: false
    }
  },
  computed: {
    ...mapGetters('comparador', ['folios', 'scrollX', 'estaAbierto'])
  },
  watch: {
    scrollX(newValue) {
      if (newValue.source !== 'headers') {
        document.getElementsByClassName('folio-headers')[0].scrollLeft =
          newValue.scrollLeft
      }
    },
    folios(newValue) {
      if (newValue && newValue.length > 0) {
        this.showScroll = true
        this.$nextTick(() =>
          document
            .getElementsByClassName('folio-headers')[0]
            .addEventListener('scroll', this.headersScrollHandle)
        )
      } else {
        document
          .getElementsByClassName('folio-headers')[0]
          .removeEventListener('scroll', this.headersScrollHandle)
        this.$nextTick(() => (this.showScroll = false))
      }
    }
  },
  destroyed() {
    const listeners = document.getElementsByClassName('folio-headers')
    if (listeners.length > 0)
      listeners[0].removeEventListener('scroll', this.headersScrollHandle)
  },
  methods: {
    headersScrollHandle(evt) {
      this.$store.commit('comparador/SET_SCROLL_HORIZONTAL', {
        scrollLeft: evt.target.scrollLeft,
        source: 'headers'
      })
    }
  }
}
</script>
